export default {"src":"/_next/static/media/camera-pink.b03b117a.svg","height":24,"width":26};